
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"98","height":"66"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1501","transform":"translate(-1287.5 -3058.5)","fill":"none","stroke":"#707070","stroke-width":"3"}},[_c('rect',{attrs:{"data-name":"Rectangle 1240","width":"44","height":"11","rx":"5.5","transform":"translate(1289 3060)"}}),_c('rect',{attrs:{"data-name":"Rectangle 1246","width":"44","height":"11","rx":"5.5","transform":"translate(1340 3060)"}}),_c('rect',{attrs:{"data-name":"Rectangle 1243","width":"44","height":"10","rx":"5","transform":"translate(1289 3087)"}}),_c('rect',{attrs:{"data-name":"Rectangle 1247","width":"44","height":"10","rx":"5","transform":"translate(1340 3087)"}}),_c('rect',{attrs:{"data-name":"Rectangle 1245","width":"44","height":"11","rx":"5.5","transform":"translate(1289 3112)"}}),_c('rect',{attrs:{"data-name":"Rectangle 1248","width":"44","height":"11","rx":"5.5","transform":"translate(1340 3112)"}})])])
          )
        }
      }
    